export const ROUTES_OVERRIDES = {};
